import name from './name'

const selectSliceData = state => state[name]

const selectPage = state => selectSliceData(state).page || null
const selectSections = state => selectSliceData(state).page?.sections || []
const selectLoading = state => selectSliceData(state).loading || false
const selectError = state => selectSliceData(state).error || null

export {
  selectPage,
  selectSections,
  selectLoading,
  selectError
}
